export default {
  widgetTitleConnexion: 'Client Portal',
  widgetTitleMultiFacteur: 'Multifactor Authentication',
  widgetTitleOktaVerify: 'Okta Verify',
  widgetTitleWindowsHello: 'Windows Hello',
  widgetTitleGoogleAuthenticator: 'Mobile app identification',
  widgetTitleExpiredPassword: 'Temporary Password',
  widgetTitleSmsCall: 'Phone Identification',
  loginError: 'The username or password is incorrect.',
  loginErrorCounter: 'Please contact us for assistance.',
  forgotUsername: 'Forgot your username?',
  username: 'Username',
  remember: 'Remember my username',
  signInButton: 'Sign In',
  signUpButton: 'Create an account',
  mfaChoiceButton: 'Choose',
  mfaChoiceDescription: 'You must enable Multi-factor authentication to add an additional layer of security when logging into your account.',
  mfaGoogleChoiceDescription: 'Use the mobile app to sign in.',
  mfaOktaVerifyChoiceDescription: 'Use the Okta Verify mobile app to sign in.',
  back: 'Back',
  passwordExpiredSubmit: '{0}',
  passwordExpiredSubtitle: 'For security purposes, you must reset your password at the next step.',
  mandatoryMessage: 'Mandatory field',
  forgotPassword: 'Forgot your password?',
  cancel: 'Back to sign in',
  'factor.call.description': 'Use a phone to sign in by following the voice instructions.',
  'enroll.totp.setupGoogleAuthApp': 'Launch {0}, tap the "+" icon, then select "Scan barcode".',
  'enroll.totp.cannotScan': 'Can\'t scan?',
  'enroll.totp.cannotScanBarcode': 'Can\'t scan QR Code?',
  'enroll.totp.manualSetupInstructions': 'To set up manually, enter your account username and then input the following in the Secret key field',
  'enroll.totp.enterCode': 'Enter the code displayed on the application',
  'mfa.challenge.enterCode.placeholder': 'Enter code',
  'mfa.challenge.enterCode.tooltip': 'Enter code',
  'factor.sms.description': 'Enter a single-use code sent to your mobile phone.',
  'factor.sms.time.warning': 'Haven\'t received an SMS? To try again, click on <$1>Re-send code</$1>.',
  'phone.extention.label': 'Extension',
  'mfa.phoneNumber.ext.placeholder': 'Extension',
  'factor.call.time.warning': 'Haven\'t received a voice call? To try again, click on <$1>Redial</$1>.',
  'enroll.totp.setupApp': 'Launch {0} on your mobile device and select "Add an account". Scan the QR code to continue.',
  'enroll.choices.optional': 'You can configure any additional optional factor or click on finish',
  'mfa.sendCode': 'Send code',
  'mfa.resendCode': 'Re-send code',
  'mfa.redial': 'Redial',
  'mfa.calling': 'Calling',
  'rememberDevice.timebased': 'Do not challenge me on this device for the next {0}',
  'oform.errorbanner.title': 'We found some errors. Please review the form and make corrections.',
};
